import React from 'react';
import { AreaClosed } from '@visx/shape';
import type { scaleLinear, scaleUtc } from '@visx/scale';
import type { PriceEntity } from '@/components/PriceChart/utils/types';

interface Props {
  data: PriceEntity[];
  fill?: string;
  fillOpacity?: string | number;
  xScale: ReturnType<typeof scaleUtc<number>>;
  yScale: ReturnType<typeof scaleLinear<number>>;
}

const Area = ({
  data,
  xScale,
  yScale,
  fill = 'white',
  fillOpacity = 0.5,
}: Props) => {
  // Convert utc to local time
  const dataGradient: [Date, number][] = data.map((d) => [
    new Date(d.date),
    d.close ?? 0,
  ]);
  return (
    <>
      <defs>
        <linearGradient
          id="gradient-fill"
          x1="0"
          x2="0"
          y1="0"
          y2={yScale.range()[0]}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="50%" stopColor={fill} />
          <stop offset="100%" stopColor="transparent" />
        </linearGradient>
      </defs>
      <AreaClosed
        data={dataGradient}
        x={([date]) => xScale(date)}
        y={([_, value]) => yScale(value || 0)}
        y0={() => yScale.range()[0]}
        yScale={yScale}
        fill="url(#gradient-fill)"
        fillOpacity={fillOpacity}
        className="pointer-events-none"
      />
    </>
  );
};

export const PriceChartArea = React.memo(Area);
